import CopyToClipboardWrapper from "./CopyToClipboardWrapper";

export default CopyToClipboardWrapper;
